module.exports = __webpack_public_path__ + "img/k-3.b19af01c.png";